export default __webpack_public_path__ + "static/media/third.1ce1d118.png";